import React from 'react';
import BaseComponent from 'src/components/BaseComponent';

import { remCss, lang } from 'src/helpers';
import { MCButton, TextField } from 'src/components/basic';

import model from './model';

export default class MobileSettings extends BaseComponent {
  componentDidMount() {
    console.log('MobileSettings mounted');
    model.subscribe(this.subscription);
    model.loadSettings();
  }

  componentWillUnmount() {
    console.log('MobileSettings unmounted');
    model.unsubscribe(this.subscription);
  }

  render() {
    let updateState = model.getApiState('setSettings');

    return (
      <div className={'mc-container-content mc-money-statistics'}>
        <div className={'mc-container-content__header'}>
          <span className={'mc-grow'}>{lang.t('Mobile Settings')}</span>
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <div className={'mc-flex-20-col'}>
              <div className={'mc-flex-20-col'}>
                <TextField
                  template={6}
                  label={'Update version'}
                  name={'minAppVersion'}
                  value={model.input('minAppVersion')}
                  onChange={model.handleChange}
                  // onBlur={model.handleBlur}
                  invalid={updateState.invalid}
                />
              </div>
              <div className={'mc-flex-20-col'}>
                <TextField
                  template={6}
                  label={'Logout version'}
                  name={'logoutAppVersion'}
                  value={model.input('logoutAppVersion')}
                  onChange={model.handleChange}
                  // onBlur={model.handleBlur}
                  invalid={updateState.invalid}
                />
              </div>
              <div>
                <MCButton
                  style={{ minWidth: remCss(130) }}
                  label={'Save'}
                  // small
                  radius
                  primary
                  dark
                  onClick={model.saveSettings}
                  disabled={updateState.loading}
                  loading={updateState.loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
